import {AxiosError} from 'axios';
import {ApiPathParam} from 'web-library/models/SearchParamSchema';
import axiosClient from '../axiosClient';
import {POST_TRANSACTION_CANDIDATE_LISTING_URL} from '../../constants/apiUrls';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: (data: CandidateListingResponseModel) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export interface CandidateListingObjectModel {
  uuid: string;
  userIdType: string;
  finNric: string;
  candidateName: string;
  examLevel: string;
}

export interface CandidateListingResponseModel {
  content: CandidateListingObjectModel[];
  totalElements: number;
}

export interface CandidateListingRequest {
  apiPathParam: ApiPathParam;
  query: string;
}

export const usePostCandidateListing = ({onSuccess, onError}: Input = {}) => {
  const postCandidateListing = async (requestData: CandidateListingRequest) => {
    const res = await axiosClient.post<CandidateListingResponseModel>(
        POST_TRANSACTION_CANDIDATE_LISTING_URL(requestData.apiPathParam),
        {
          q: requestData.query ?? '',
        }
    );
    return res.data;
  };

  return useCustomMutation(postCandidateListing, {
    onSuccess,
    onError,
  });
};
